import React from 'react'
import './wwd.less'
import WeDream from '../../../images/weStillDream.jpeg'

export default ()=>{
    return(
        <section className="what-we-do-container">
            <article className="about-content-image two anim-three" data-delay="0.2s">
                <img src={WeDream} alt="WeStillDream"></img>
            </article>
            <article className="about-content anim-three" data-delay="0s">
                <h4 className="sub-heading anim-three" data-delay="0.2s">
                    What We Do
                </h4>
                <p className="about-text anim-three" data-delay="0.4s">
                    Empower is a dedicated initiative that focuses on the sustainable support provided for people in need in Sri Lanka through bridging those who are willing to help and those who seek help. We
                    are dedicated to help people through their tough times in Sri Lanka and change the
                    perspectives of the capabilities of every human.
                    As the world is reeling from the effects of the pandemic, we are here to remind you that there is nothing that we can’t achieve if we all partner together.
                </p>
            </article>
        </section>
    )
}